module.exports = __webpack_public_path__ + "static/media/new-ideas.33ac3a55.png";